import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export type Dv360IconProps = SvgIconProps;

export function Dv360Icon(props: Dv360IconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 2192.7 2428.1" {...props}>
      <path
        fill="#81C995"
        d="M1730.6,949.3c142.5-86.5,328.1-41.1,414.5,101.4c86.5,142.5,41.1,328.1-101.4,414.5
          c-3.8,2.3-7.6,4.5-11.4,6.6L460.2,2377.1c-142.5,86.5-328.1,41.1-414.6-101.4c-86.5-142.5-41.1-328.1,101.4-414.6
          c3.8-2.3,7.6-4.5,11.4-6.6L1730.6,949.3z"
      />
      <path
        fill="#34A853"
        d="M601,303.7C601.7,137.4,467.4,1.9,301.1,1.2c-21.4-0.1-42.7,2.1-63.7,6.5C96.5,42.3-2,169.5,0,314.7v1798.1
          l600.4,10.9L601,303.7z"
      />
      <path
        fill="#5BB974"
        d="M1737.4,1472.9c145.3,75.3,324.1,27.1,411.9-111.1c84.4-142,37.7-325.6-104.3-410c-1.1-0.6-2.1-1.2-3.2-1.9
          L459.2,43C318.3-42.1,135,3.1,49.8,144c-2.1,3.5-4.2,7.1-6.2,10.7C-40,297.8,8.2,481.7,151.3,565.4c1,0.6,2,1.1,3,1.7
          L1737.4,1472.9z"
      />
      <path
        fill="#81C995"
        d="M2031.4,1475L600.5,2274.3v-686.6l1135.4-633.1c150.5-83.4,340.2-29,423.6,121.6c7.8,14,14.4,28.6,19.9,43.6
          C2222,1258.3,2159.8,1407.6,2031.4,1475z"
      />
      <circle fill="#1E8E3E" cx="300.8" cy="2127.8" r="300.2" />
    </SvgIcon>
  );
}
